<div class="modal-content">
  <h2 class="modal-header">¡No te quedes fuera!</h2>
  <h5 class="modal-message">
    Para disfrutar de <strong>{{ data.name }}</strong
    >, solo falta que aceptes los Términos y Condiciones.
    <a [href]="data.tyc" target="_blank">Disponible aquí</a>, ¡haz clic y únete!
  </h5>

  <div class="modal-buttons">
    <ion-button fill="outline" color="primary" (click)="closeModal()"
      >Cancelar</ion-button
    >
    <ion-button color="primary" (click)="acceptTerms()">Aceptar</ion-button>
  </div>
</div>
